import { useTranslation } from 'react-i18next'

import { TimerIcon } from '@phosphor-icons/react'

import { transactionsAnalyticsStatsValues } from '@reveni-io/reveni-ui'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'
import { statisticStatuses } from '@/common/components/Statistic/constants'
import Statistic from '@/common/components/Statistic/Statistic'

const TransactionsAboutToExpire = ({ transactionsAboutToExpire, onClick }) => {
  const { t } = useTranslation()
  const count = Number(transactionsAboutToExpire)
  const hasValue = count > 0

  return (
    <Statistic
      size="small"
      status={hasValue ? statisticStatuses.danger : statisticStatuses.default}
      Icon={TimerIcon}
      label={t('Transacciones a punto de expirar')}
      showStatusIcon={hasValue}
      value={<AnimatedNumber target={count} format="decimal" />}
      onClick={() => onClick(transactionsAnalyticsStatsValues.aboutToExpire)}
    />
  )
}

export default TransactionsAboutToExpire
